import { jsx as _jsx } from "react/jsx-runtime";
import { RequestNotification } from '@src/components/Employee/RequestNotification';
import { useMyActivities } from '@src/hooks/useMyActivities';
import { useEffect } from 'react';
import styles from './RequestNotifications.module.scss';
export const RequestNotifications = () => {
    const { myActivities, error, loading, setFilter, refetch } = useMyActivities({
        key: 'requestNotifications',
    });
    useEffect(() => {
        setFilter(prev => ({
            ...prev,
            status: ['info_needed', 'needs_correction', 'denied', 'not_covered', 'awaiting_documents'],
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (loading || error) {
        return null;
    }
    return (_jsx("div", { className: styles.notifications, children: myActivities?.map(activity => (_jsx(RequestNotification, { activity: activity, onReviewed: refetch }, activity.id))) }));
};
